import styled from "styled-components";

export const Main = styled.main`
	height: 100%;	
`